var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6758 10.0299H1.08789M14.5125 1.76855V5.89921M6.25121 1.76855V5.89921M6.04467 22.4218H14.719C16.4541 22.4218 17.3216 22.4218 17.9843 22.0842C18.5672 21.7871 19.0412 21.3132 19.3382 20.7303C19.6758 20.0676 19.6758 19.2001 19.6758 17.465V8.79067C19.6758 7.05563 19.6758 6.18811 19.3382 5.52541C19.0412 4.94249 18.5672 4.46856 17.9843 4.17154C17.3216 3.83388 16.4541 3.83388 14.719 3.83388H6.04467C4.30964 3.83388 3.44212 3.83388 2.77942 4.17154C2.1965 4.46856 1.72257 4.94249 1.42555 5.52541C1.08789 6.18811 1.08789 7.05563 1.08789 8.79067V17.465C1.08789 19.2001 1.08789 20.0676 1.42555 20.7303C1.72257 21.3132 2.1965 21.7871 2.77942 22.0842C3.44212 22.4218 4.30964 22.4218 6.04467 22.4218Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f7a9b40c65e264dce0e375fe2d8c8b2c.svg";
export { ForwardRef as ReactComponent };